<template>
  <v-card outlined :loading="loading">
    <v-card-title>
      RESUMENES
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field
              type="date"
              label="Fecha:"
              v-model="fechaInicial"
          />
        </v-col>
        
        
        <v-col cols="12" md="2">  
          <v-btn color="blue-darken-4" title="Imprimir Reporte" class="mt-3"
            @click="imprimir()" :loading="loading">
            <v-icon>mdi-printer</v-icon>Imprimir
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-btn @click="getResumenTotalizado" color="success" :loading="loading">Resumen Totalizado</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h3 class="text-center">RESUMEN TOTALIZADO <br> DE LOS RECAUDOS COBRADOS</h3>
        </v-col>
      </v-row>
      <v-row>
      <div id="areaImpresion">
        <head-report :title="`RESUMEN TOTALIZADO <br> DE LOS RECAUDOS COBRADOS `" :subtitle="` <strong> (Facturacion y Otros Ingresos)</strong> <br> Correspondiente a la Fecha: ${fechaLiteral} `"/>
        <v-simple-table class="simple-table" style="border-collapse: initial !important;">
          <thead>
          <tr>
            <th rowspan="2">CAJA <br> Nro.</th>
            <th rowspan="2">RESPONSABLE DE CAJA</th>
            <th rowspan="2">N° <br>Suc.</th>
            <th colspan="3">FACTURACION</th>
            <th colspan="3">OTROS INGRESOS</th>
            <th rowspan="2">TOTAL <br> FACTURAS <br> COBRADAS</th>
            <th rowspan="2">TOTAL MONTO <br> COBRADO Bs.</th>
            <th rowspan="2">TOTAL <br> FACTURAS <br> ANULADAS</th>
          </tr>
          <tr>
            <th>NRO. FACT. COB.</th>
            <th>MONTO COBRADO Bs.</th>
            <th>FACT. ANUL.</th>
            <th>NRO. FACT. COB.</th>
            <th>MONTO COBRADO Bs.</th>
            <th>FACT. ANUL.</th>
          </tr>
          </thead>
          <tbody>
            <template v-for="item in resumenTotalizado" >
              <tr v-for="(detalle, index) in item.detalle" :key="index">
                <td class="print">{{ detalle.numero_caja }}</td>
                <td>{{ detalle.nombre }}</td>
                <td class="print_right">{{ detalle.sucursal }}</td>

                <td class="print_right">{{ detalle.cantidad_consumo }}</td>
                <td class="print_right">{{ detalle.monto_consumo  }}</td>
                <td class="print_right">{{ detalle.cantidad_consumo_anulado }}</td>

                <td class="print_right">{{ detalle.cantidad_otros }}</td>
                <td class="print_right">{{ detalle.monto_otros }}</td>
                <td class="print_right">{{ detalle.cantidad_otros_anulado }}</td>

                <td class="print_right">{{ detalle.total_facturas_cobradas }}</td>
                <td class="print_right">{{ detalle.total_monto_cobrado  }}</td>
                <td class="print_right">{{ detalle.total_facturas_anuladas  }}</td>
              </tr> 
              <tr :key="item.entidad" style="background-color: #EAEAEA;"> 
                <th class="text-subtitle-1 font-weight-bold borde_izq"></th>
                <th class="text-subtitle-1 font-weight-bold borde_izq">{{ item.entidad  }}</th>
                <th></th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_cantidad_consumo }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_consumo }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_anulados_consumo }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_cantidad_otros }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_otros }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_anulados_otros }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_facturas_cobradas }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_monto_cobrado }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_facturas_anuladas }}</th>
              </tr>
              
            </template>
            <tr style="background-color: #EAEAEA;">
              <th class="text-subtitle-1"></th>
              <th class="text-subtitle-1">TOTALES</th>
              <th class="text-subtitle-1"></th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_cantidad_consumo }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_monto_cobrado }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_anulados_consumo }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_cantidad_otros }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_monto_otros  }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_anulados_otros }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_total_facturado }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_total_monto }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotales.final_total_anulado }}</th>

            </tr>
          </tbody>
        </v-simple-table>
      </div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {recaudacionStore} from "@/store/recaudacionStore";
import {RecaudacionService} from "@/services/RecaudacionService";
import FacturaHistorial from "@/views/facturas/FacturaHistorial.vue";
import { Reporte } from "@/addons/Reporte";
import HeadReport from "@/components/HeadReport.vue";

@Component({
  name: "FacturaIndex",
  components: {FacturaHistorial, HeadReport}
})
export default class FacturaIndex extends Vue {
  private patterns = Pattern;
  private recaudacionStore = recaudacionStore();
  private recaudacionService = RecaudacionService.getInstance();

  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");

  get fechaLiteral(): string {
    return this.recaudacionStore.fechaLiteral;
  }
  get resumenTotalizado(): any[] {
    return this.recaudacionStore.resumenTotalizado;
  }
  get resumenTotalizadoTotales(): any[] {
    return this.recaudacionStore.resumenTotalizadoTotales;
  }
  
  get loading(): boolean {
    return this.recaudacionStore.loading;
  }


  mounted() {
    //this.listar();
  }

  imprimir() {
    const css = ".print {border-top-left-radius: 5px !important; border-bottom-left-radius: 7px; border-color: red;} .emision { font-size: x-small !important; font-style: italic !important; }"
    const p = new Reporte('areaImpresion');
    p.orientacion = 'horizontal';
    p.otroCss = css;
    p.imprimir();

  }

  getResumenTotalizado() {
    this.recaudacionStore.resumenTotalizado = [];
    this.recaudacionStore.resumenTotalizadoTotales = [];
    const data = {
      fecha: this.fechaInicial,
    };
    this.recaudacionService.resumenTotalizado(data);
  }

}
</script>

<style scoped>
tr:nth-child(even) {
  background-color: #FAFAFA;
}

.simple-table {
  border: 1px solid #DDDDDD;
}
.simple-table th {
  border: 1px solid #DDDDDD;
  padding: 5px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  background-color: #EAEAEA;
}
.simple-table td {
  border: 1px solid #DDDDDD;
  padding: 5px;
  font-size: 12px;
}
</style>